import { FC, useEffect } from 'react'
import { useRouter } from 'next/router'
import {
  Control,
  FieldErrors,
  UseFormClearErrors,
  UseFormGetValues,
  UseFormHandleSubmit,
} from 'react-hook-form'

import Auth from 'store/auth'
import Button from 'components/parts/button/button'
import ControllerBaseInput from 'components/form-parts/controller-hook-forms/controller-base-input/controller-base-input'
import useActivePopupStatus from 'store/common/useActivePopupStatus'

import { concatParams, cutHashFromURL, getParams } from 'utils/getURLData'
import { MAIN_PAGE_URL, PROMO_REDIRECT_URL } from 'constants/data'
import { FormValues } from '../../data'
import { FieldsNameVoc, fullNameValidation, workplceValidation } from 'constants/auth/profile-data'
import { profileURL } from 'constants/url'
import { putAxiosSingle } from 'pages/api/axios'
import {
  A_personalInfoShow,
  A_personalInfoSucces,
} from 'utils/analytics/other/registration/registration'

import common from '../../registration-code.module.scss'

interface IDopInpurWidget {
  control: Control<FormValues>
  errors: FieldErrors
  clearErrors: UseFormClearErrors<FormValues>
  getValues: UseFormGetValues<FormValues>
  handleSubmit: UseFormHandleSubmit<FormValues>
  handleClose: () => void
}

const getPath = (path: string) => {
  const params = getParams(path)
  const formedParams = concatParams(params)
  const completePath = formedParams ? `${MAIN_PAGE_URL}?${formedParams}` : MAIN_PAGE_URL
  return completePath
}

const DopInpurWidget: FC<IDopInpurWidget> = ({
  control,
  errors,
  getValues,
  clearErrors,
  handleSubmit,
  handleClose,
}) => {
  const isButtonDisabled = Boolean(errors[FieldsNameVoc.fullName])
  const router = useRouter()
  const path = cutHashFromURL(router.asPath)

  const { userProfile } = Auth.useAuth()
  const { setCurrentProfile } = Auth.useHandleAuth()
  const { setHashPopupStatus } = useActivePopupStatus()

  const enterHandler = async () => {
    const userInfo = getValues()
    const [lastName, firstName, secondName] = userInfo[FieldsNameVoc.fullName].trim().split(' ')

    if (!lastName) return

    const formatedData = {
      [FieldsNameVoc.firstName]: firstName,
      [FieldsNameVoc.lastName]: lastName,
      [FieldsNameVoc.secondName]: secondName,
      [FieldsNameVoc.workplace]: userInfo[FieldsNameVoc.workplace],
    }
    await putAxiosSingle(profileURL, {}, { ...formatedData })
    setCurrentProfile({
      ...userProfile,
    })
    A_personalInfoSucces()
    handleClose()
  }

  useEffect(() => {
    const redirect = () => {
      const url = path === PROMO_REDIRECT_URL ? getPath(path) : path
      router.replace(url, undefined, { shallow: true })
      setHashPopupStatus()
    }
    A_personalInfoShow()
    return () => redirect()
  }, [])

  return (
    <div className={common.wrapperCommon}>
      <div className={common.title}>Личные данные</div>
      <div className={common.subtitle}>Заполните поля для полного доступа к порталу.</div>
      <div className={common.inputWrap}>
        <ControllerBaseInput
          control={control}
          name={FieldsNameVoc.fullName}
          errors={errors}
          noErrorOnTouch={clearErrors}
          rules={fullNameValidation}
        />
      </div>
      <div className={common.inputWrap}>
        <ControllerBaseInput
          control={control}
          name={FieldsNameVoc.workplace}
          rules={workplceValidation}
          noErrorOnTouch={clearErrors}
          errors={errors}
        />
      </div>
      <Button disabled={isButtonDisabled} onClick={handleSubmit(enterHandler)}>
        Сохранить
      </Button>
    </div>
  )
}

export default DopInpurWidget
